<ion-header class="header --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.home" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <span [innerHTML]="'REPORT_DETAIL.BREADCRUMB_NAME' | translate"></span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="report-detail">
  <div class="white-wrapper">
    <div class="report-detail__header">
      <ion-item class="report-detail__header__title" lines="none">
        <ion-text [innerHTML]="date | date:'MMMM YYYY'"></ion-text>
      </ion-item>
      <ion-icon
        class="report-detail__header__ellipsis"
        slot="icon-only"
        name="ellipsis-vertical"
        (click)="presentPopover($event)"
      ></ion-icon>
    </div>

    <div class="report-detail__content">
      <div class="report-detail__content__left" [class.--no-action-button]="!showActionButton">
        <div class="report-detail__content__left__report" *ngFor="let report of reports$ | async">
          <app-report-kpi
            class="report-detail__content__left__report__kpi"
            [class.--is-danger]="report.isBottleneck && showActionButton"
            [actionButton]="showActionButton ? (actionButton$ | async) : null"
            [report]="report"
          ></app-report-kpi>
          <div *ngIf="report.isBottleneck && showActionButton" class="connector"></div>
        </div>
      </div>

      <div
        *ngIf="showActionButton"
        class="report-detail__content__right"
        [class.--shown-on-mobile]="!(actionButton$ | async | isRelatedToReport:(reports$ | async))"
      >
        <app-report-action-button
          class="report-detail__content__right__action-button"
          [actionButton]="actionButton$ | async"
        ></app-report-action-button>
      </div>
    </div>
  </div>

  <div #print class="print-only">
    <app-logo></app-logo>
    <h1
      [style.fontSize.px]="22"
      [style.marginTop.px]="20"
      [innerHTML]="'REPORT_DETAIL.PRINT_HEADLINE' | translate:{ name: (definition$ | async)?.name, date: date | date:'MMMM YYYY' }"
    ></h1>
    <h2
      *ngIf="showActionButton"
      [style.fontSize.px]="22"
      [style.marginTop.px]="0"
      [innerHTML]="'REPORT_DETAIL.YOUR_BOTTLENECK' | translate:{ bottleneck: (actionButton$ | async)?.title }"
    ></h2>
    <p
      *ngIf="showActionButton"
      [style.fontSize.px]="16"
      [innerHTML]="'REPORT_DETAIL.INTRO' | translate:{ intro: (actionButton$ | async)?.intro }"
    ></p>
    <table [style.fontSize.px]="16" [style.cell-padding.px]="12" [style.margin]="'0 auto'">
      <tbody>
        <tr
          *ngFor="let report of reports$ | async"
          [style.background-color]="report.isBottleneck ? '#EACCCC' : report.status === 'success' ? '#E1EDE1' : '#FFE4B5'"
        >
          <td [innerHTML]="(report.dataDefinitionId | toDataDefinition | async)?.description" [style.padding.px]="8"></td>
          <td
            [innerHTML]="report?.value | parseReportValue: (report?.dataDefinitionId | toDataDefinition | async)"
            [style.padding.px]="8"
          ></td>
          <td [style.padding.px]="8">
            <img
              *ngIf="report | parseReportEmoji; let source"
              [style.border.px]="0"
              [style.width.px]="30"
              [style.height.px]="30"
              [style.margin.px]="0"
              [src]="source"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <p *ngIf="showActionButton" [style.fontSize.px]="22" [innerHTML]="(actionButton$ | async)?.message"></p>
  </div>
</ion-content>
